

export abstract class BaseReportParameters {
  protected readonly localStorageFormParametersProperty: string;

  //private lastSaved: Date

  constructor(localStorageFormParametersProperty: string) {
    this.localStorageFormParametersProperty = localStorageFormParametersProperty

    this.getParametersBase();
  }

  public storeParameters() {
    //this.lastSaved = new Date()

    let stringified = JSON.stringify(this, (key, value) => key == "localStorageFormParametersProperty" ? undefined : value);

    localStorage.setItem(this.localStorageFormParametersProperty, stringified);
  }

  public clearParameters() {
    localStorage.removeItem(this.localStorageFormParametersProperty);
  }

  protected abstract getParameters(storedParameters: any): void

  private getParametersBase() {
    const storedParameters: any = JSON.parse(localStorage.getItem(this.localStorageFormParametersProperty) ?? '{}');

    //logic to reset parameters if last saved is too old
    // if (storedParameters != null && storedParameters instanceof BaseReportParameters){
    //   let stored = storedParameters as BaseReportParameters

    //   if (stored?.lastSaved != null && this.gapInDaysBeforeNow(stored.lastSaved) > 1){
    //       this.clearParameters()

    //       return this.getParametersBase()
    //   }
    // }

    this.getParameters(storedParameters);

    this.storeParameters();
  }

  // private gapInDaysBeforeNow(oldDate: Date): number {
  //   let currentDate = new Date();

  //   let gapInDays = Math.floor((Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()) - Date.UTC(oldDate.getFullYear(), oldDate.getMonth(), oldDate.getDate()) ) /(1000 * 60 * 60 * 24));

  //   return gapInDays
  // }
}
